export const CREATE_ORDER_MUTATION = `
mutation OrderMutation {
  create {
    data {
      orderState
      orderId
    }
  }
}
`;
